module.exports = __webpack_public_path__ + "static/media/serviceimg_03.e72899d4.svg";